import React from "react";

import { Spin } from "antd";

import { LoadingOutlined } from "@ant-design/icons";

const LoadingPage = (props) => {
  const { style } = props;
  return (
    <div style={style || { textAlign: "center", paddingTop: "34vh" }}>
      <Spin
        spinning
        indicator={
          <LoadingOutlined style={{ fontSize: 60, color: "#d9d9d9" }} spin />
        }
      ></Spin>
    </div>
  );
};

export default LoadingPage;
